import AOS from 'aos'
// The Modal Import is required for the hubspot implementation
import { Modal } from 'bootstrap'
import NavigationDesktop from './Modules/NavigationDesktop'
import NavigationMobile from './Modules/NavigationMobile'
import LanguageNavigation from './Modules/LanguageNavigation'
import MetaNavigationScroll from './Modules/MetaNavigationScroll'
import RefreshAosOnResize from './Modules/RefreshAosOnResize'
import initializeHubSpotFormHandlers from './Modules/HubSpotFormHandler'
import initializeCookieConsentContent from './Modules/CookieConsentContent'
import ScrollRelatedComponent from './Modules/ScrollRelatedComponent'
import ModalExtractor from './Modules/ModalExtractor'
import OnPageNavigationController from './Modules/OnPageNavigationController'
import CountryPopup from './Modules/CountryPopup'
import {scrollProgressBar} from './Modules/ScrollProgressBar'
import AnchorButtons from './Modules/AnchorButtons'
import {ScrollToTop} from './ScrollToTop'
import CtaButton from './CtaButton'
import {ScrollToNextSection} from './Modules/ScrollToNextSection'
import LottieAnimator from './LottieAnimator'
import initTypingAnimations from './Modules/TypingAnimation'
import initCSPEmails from "./Modules/CSPEmails";
import HistoryTimelineScroller from './HistoryTimelineScroller'

const initNodeTypesOnLoad = function () {
    AOS.init()
    new NavigationDesktop()
    new NavigationMobile()
    const languageNavigation = new LanguageNavigation()
    new MetaNavigationScroll(languageNavigation)
    new ScrollRelatedComponent()
    new RefreshAosOnResize()
    initializeHubSpotFormHandlers()
    initializeCookieConsentContent(window.OneTrust)
    new ModalExtractor()
    new OnPageNavigationController()
    new CountryPopup()
    scrollProgressBar()
    new AnchorButtons()
    new ScrollToTop()
    new CtaButton()
    new ScrollToNextSection()
    new LottieAnimator()
    initTypingAnimations()
    initCSPEmails()
    new HistoryTimelineScroller()
}

if (document.readyState != 'loading') {
    initNodeTypesOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad)
}
